import { render, staticRenderFns } from "./AssignWork.vue?vue&type=template&id=bcac29b6&scoped=true&"
import script from "./AssignWork.vue?vue&type=script&lang=js&"
export * from "./AssignWork.vue?vue&type=script&lang=js&"
import style0 from "./AssignWork.vue?vue&type=style&index=0&id=bcac29b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcac29b6",
  null
  
)

component.options.__file = "AssignWork.vue"
export default component.exports